var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6422 7.37977L19.5769 0.452043C19.1163 0.166604 18.5736 0 17.9929 0H3.0301C2.52537 0 2.05128 0.124956 1.63477 0.345477L9.69182 7.37983C10.2468 7.86619 11.0847 7.86619 11.6396 7.37983L11.6422 7.37977Z",
    fill: "#002A54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00482215 3.02589V12.6535C0.00482215 14.322 1.36217 15.6794 3.03069 15.6794H17.9898C19.6583 15.6794 21.0156 14.322 21.0156 12.6535V3.02589C21.0156 2.50893 20.8833 2.0189 20.6518 1.59258L14.5144 6.95224L18.8585 11.1173C19.1721 11.4187 19.1819 11.9136 18.8806 12.2273C18.7274 12.3877 18.5204 12.4686 18.3158 12.4686C18.121 12.4686 17.9238 12.3963 17.7731 12.2493L13.3286 7.98729L12.6695 8.56061C12.0986 9.05919 11.3807 9.31033 10.6629 9.31033C9.945 9.31033 9.22956 9.0592 8.65624 8.56061L7.99715 7.98729L3.55261 12.2493C3.40193 12.3939 3.20469 12.4686 3.0099 12.4686C2.80287 12.4686 2.59951 12.3865 2.44515 12.2273C2.14378 11.9136 2.15603 11.4187 2.4672 11.1173L6.81138 6.95224L0.470421 1.41382C0.172732 1.88057 0 2.43306 0 3.02843L0.00482215 3.02589Z",
    fill: "#002A54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.cf5382c3aa1d8ac19cb20fb2c7dc8b66.svg";
export { ForwardRef as ReactComponent };